const metadataToRequestError = (metadata) => {
  if (metadata.status === 401) {
    return {
      type: "unauthorized"
    };
  }
  return {
    type: "networkError",
    metadata
  };
};
export {
  metadataToRequestError
};
//# sourceMappingURL=metadataToRequestError.js.map
